var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Popup",
    {
      attrs: { position: "bottom" },
      on: { open: _vm.open, close: _vm.cancel },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _c(
        "div",
        { staticClass: "select-content" },
        [
          _c("div", { staticClass: "select-header" }, [
            _c("div", { staticClass: "title" }, [
              _vm._v(_vm._s(_vm.selectTitle)),
            ]),
          ]),
          _vm.selectTitle === "E-Wallet/Bank Name"
            ? _c("van-field", {
                staticClass: "input",
                attrs: { "right-icon": "search", placeholder: "Search Bank" },
                on: { input: _vm.input, focus: _vm.focus },
                model: {
                  value: _vm.inputValue,
                  callback: function ($$v) {
                    _vm.inputValue = $$v
                  },
                  expression: "inputValue",
                },
              })
            : _vm._e(),
          _vm.nowColumns.length
            ? _c(
                "div",
                { staticClass: "list", class: { showSearch: _vm.showSearch } },
                _vm._l(_vm.nowColumns, function (item, index) {
                  return _c(
                    "div",
                    {
                      key: item.label,
                      staticClass: "list-item",
                      class: _vm.activeIndex == index ? "active" : "",
                      on: {
                        click: function ($event) {
                          return _vm.getResult(item)
                        },
                      },
                    },
                    [_c("p", [_vm._v(_vm._s(item.label))])]
                  )
                }),
                0
              )
            : _vm._e(),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }